import styled from 'styled-components';
import Theme from 'app/theme';

export const BlurBoxBase = styled.div`
    backdrop-filter: ${() =>
        `blur(${Theme.BLUR_AMOUNT}px)
        brightness(${Theme.BLUR_BRIGHTNESS}%)
        contrast(${Theme.BLUR_CONTRAST}%)
        saturate(${Theme.BLUR_SATURATE}%)
    `};
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 20px;
`;
